module.exports = __webpack_public_path__ + "img/comment-outline.496e2cd1.svg";